<template>
  <base-operation-box :isFooter="true" title="Conta a ser depositado">
    <template #icon-title>
      <base-icon
        name="painel/shield-icon"
        width="24"
        height="24"
        class="has-text-secondary has-text-support"
      />
    </template>
    <template>
      <div class="columns is-gapless is-mobile c-pix-key-details">
        <div
          class="column is-narrow c-pix-key-details__data--pix has-text-right"
        >
          PIX
        </div>
        <div class="column c-pix-key-details__data--user has-text-left">
          <p class="column c-pix-key-details__data--user-name">
            {{ userDataTransfer && userDataTransfer.owner_full_name }}
          </p>
          <p class="column c-pix-key-details__data--user-info">
            <strong>{{ pixKey }}</strong>
            {{ userDataTransfer && userDataTransfer.pix_key }}
            <br />
            {{ bankName }}
          </p>
        </div>
      </div>
    </template>
  </base-operation-box>
</template>

<script>
import BaseOperationBox from '@/components/Wallet/BaseOperationBox.vue'

export default {
  components: {
    BaseOperationBox,
  },

  computed: {
    userDataTransfer() {
      return this.$store.state.wallet.userDataTransfer
    },

    bankName() {
      return this.userDataTransfer?.bank?.name || ''
    },

    pixKey() {
      switch (this.userDataTransfer?.pix_type || '') {
        case 'cpf':
          return 'CPF:'
        case 'evp':
          return 'Chave aleatória:'
        case 'email':
          return 'E-mail:'
        case 'phone':
          return 'Celular:'
        default:
          return 'Chave PIX:'
      }
    },
  },
}
</script>

<style lang="scss">
.c-pix-key-details {
  display: inline-flex !important;
  max-width: 360px;
  padding: 0 15px;
  margin: 0 auto;

  &__data {
    text-align: left;

    @media (min-width: $tablet) {
      text-align: center;
    }

    &--pix {
      font-size: 12px;
      line-height: 1.33;
      font-weight: bold;
      color: $support;
      margin-right: 10px !important;
      margin-top: 2px !important;
    }

    &--user-name {
      font-size: 16px;
      color: $gray-6;
      font-weight: bold;
      line-height: normal;
      letter-spacing: normal;
      padding: 0;
    }

    &--user-info {
      font-size: 14px;
      line-height: normal;
      letter-spacing: normal;
      color: $gray-5;
      padding: 0;
    }
  }

  &__btn-change {
    text-align: right;
    @media (min-width: $tablet) {
      text-align: center;
    }
  }
}
</style>
